import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { HeaderComponent } from './header/header.component';
import { CustomGridComponent } from './custom-grid/custom-grid.component';
import { ColumnsDefinition, CustomGridSettings, GridEvent, GridState } from './custom-grid/grid.models';

@NgModule({
  declarations: [
    BreadcrumbsComponent,
    SidebarComponent,
    HeaderComponent
  ],
  exports: [
    BreadcrumbsComponent,
    SidebarComponent,
    HeaderComponent,
    // CustomGridComponent,
    // CustomGridSettings,
    // ColumnsDefinition,
    // GridEvent,
    // GridState
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatProgressSpinnerModule
    
  ]
})
export class SharedModule { }
